import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  legal_name: "BSGOTECH [LEGAL SUFFIX]",
  country: "São Tomé and Príncipe",
  registered_office: "[TO BE CONFIRMED]",
  nif: "[TO BE CONFIRMED]",
  commercial_registration: "[TO BE CONFIRMED]",
  email: "contact@bsgotech.com",
  phone: "+239 000 0000",
  whatsapp: "+239 000 0000",
  whatsapp_message: "Hello BSGOTECH, I would like to discuss a project.",
  privacy_email: "[TO BE CONFIRMED]",
  privacy_updated: "[TO BE CONFIRMED]",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    api.get("/settings").then((res) => setSettings({ ...DEFAULTS, ...res.data })).catch(() => {});
  }, []);

  return <SettingsContext.Provider value={{ settings, setSettings }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
